import React from "react"
import { Link } from "gatsby"

import AboutImg1 from "../../assets/images/about-img1.webp"

const AboutSection = () => {
  return (
    <>
      <div className="about-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="about-image">
                <img src={AboutImg1} alt="About" />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <span className="sub-title">APCV</span>
                  <h2>Gồm nhiều chuyên gia về thị giác máy tính</h2>
                  <p>
                  Là đối tác đáng tin cậy, hỗ trợ doanh nghiệp hiểu rõ tiềm năng của ứng dụng trí tuệ nhân tạo để tự động hóa các quy trình.
                  </p>

                  <ul className="funfacts-list">
                    <li>
                      <div className="list">
                        <i className="flaticon-menu-1"></i>
                        <h3>7</h3>
                        <p>Dự án</p>
                      </div>
                    </li>
                    <li>
                      <div className="list">
                        <i className="flaticon-web-settings"></i>
                        <h3>30</h3>
                        <p>Mô hình</p>
                      </div>
                    </li>
                    <li>
                      <div className="list">
                        <i className="flaticon-conversation"></i>
                        <h3>12</h3>
                        <p>Thành viên</p>
                      </div>
                    </li>
                  </ul>

                  <Link to="/about-us-1" className="default-btn">
                    Xem thêm về An Phát
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutSection
